export default "__VITE_PUBLIC_ASSET__a668751b__"